<template>
  <div class="cardTicket-detail">
    <div class="msg">
      <h1>详情</h1>
      <ul>
        <li>
          <span>卡券名称：</span>
          <span>{{detailData.ticketName}}</span>
        </li>
        <li>
          <span>卡券内容：</span>
          <span>{{detailData.ticketContent}}</span>
        </li>
        <li>
          <span>卡券日期：</span>
          <span>
            {{detailData.ticketBeginTime | filterDate}} ~ {{detailData.ticketEndTime | filterDate}}
          </span>
        </li>
        <li>
          <span>已兑换数量：</span>
          <span>{{detailData.finishExchange}}</span>
        </li>
        <li>
          <span>未兑换数量：</span>
          <span>{{detailData.noExchange}}</span>
        </li>
      </ul>
    </div>
    <div class="record">
      <h1>卡券拥有账户</h1>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="拥有人" align="left"></el-table-column>
        <el-table-column prop="finishTime" label="兑换时间" align="left"></el-table-column>
        <el-table-column label="兑换状态" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.ticketState === 1">未使用</span>
            <span v-else-if="scope.row.ticketState === 2">已使用</span>
            <span v-else>已过期</span>
          </template>
        </el-table-column>
        <el-table-column prop="exchangeShop" label="兑换店铺" align="left"></el-table-column>
        <el-table-column prop="exchangeUser" label="兑换店员" align="left"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getAssistantTicketAndUser } from '@/api/cardTicket';
import { formatDate } from '@/utils/util';

export default {
  data() {
    return {
      detailData: {},
      tableData: [],
    };
  },
  filters: {
    filterDate: (value) => formatDate(value),
  },
  mounted() {
    this.getAssistantTicketAndUser();
  },
  methods: {
    // 礼品券获取详情
    getAssistantTicketAndUser() {
      const { id } = this.$route.query;
      getAssistantTicketAndUser(id).then((res) => {
        if (res.success && res.data) {
          const { myTickets } = res.data;
          this.detailData = res.data;
          this.tableData = myTickets;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.cardTicket-detail
  .msg
    border-bottom 1px solid #e8e8e8
    padding-bottom 24px
    h1
      margin-bottom 20px
      color rgba(0, 0, 0, 0.85)
      font-weight 700
      font-size 16px
      line-height 1.5
    ul
      flex-row()
      align-items flex-start
      li
        width 25%
        padding 0 20px 16px 20px
        span
          line-height 22px
  .record
    margin-top 30px
    h1
      margin-bottom 16px
      color rgba(0, 0, 0, 0.85)
      font-weight 500
      font-size 16px
</style>
